var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-card",
        { staticClass: "yxtbiz-appraise-mode", attrs: { shadow: "never" } },
        [
          _c(
            "yxt-form",
            {
              ref: "dataForm",
              staticClass: "yxtbiz-appraise-form",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "77px",
              },
            },
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_biz_appraise_auto_result" /*自动评估*/),
                  },
                },
                [
                  _c("yxt-switch", {
                    attrs: {
                      "active-text": _vm.$t(
                        "pc_biz_appraise_close_explain" /*若关闭，需手动鉴定合格*/
                      ),
                    },
                    on: { change: _vm.handleChangeEnable },
                    model: {
                      value: _vm.dataForm.autoPass,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "autoPass", $$v)
                      },
                      expression: "dataForm.autoPass",
                    },
                  }),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                { attrs: { prop: "num" } },
                [
                  _c(
                    "language-slot",
                    {
                      attrs: {
                        "lang-key":
                          _vm.dataForm.type === 1
                            ? "pc_biz_appraise_pass_over_percentage"
                            : "pc_biz_appraise_pass_over_score",
                      },
                    },
                    [
                      _c("yxt-input-number", {
                        staticClass: "yxtbiz_appraise_num_input mr6",
                        attrs: {
                          size: "large",
                          disabled: !_vm.dataForm.autoPass,
                          precision: 1,
                          min: _vm.dataForm.type === 1 ? 0.1 : 0,
                          max: 100,
                        },
                        on: {
                          change: _vm.handleChangeNum,
                          input: _vm.handleChangeNum,
                        },
                        model: {
                          value: _vm.dataForm.num,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "num", $$v)
                          },
                          expression: "dataForm.num",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                {
                  staticClass: "yxtbiz-appraise-choose-template",
                  attrs: {
                    label: _vm.$t(
                      "pc_biz_appraise_choose_template" /*选择模板*/
                    ),
                    prop: "template",
                  },
                },
                [
                  _c(
                    "yxt-button",
                    {
                      staticClass: "yxtbiz-appraise-questionnaire-btn",
                      attrs: {
                        type: "primary",
                        size: "large",
                        disabled: !!_vm.isPublished,
                      },
                      on: { click: _vm.chooseFormWork },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_appraise_choose_template" /*选择模板*/)
                        )
                      ),
                    ]
                  ),
                  _vm.dataForm.template && _vm.dataForm.template.id
                    ? _c("ul", [
                        _c(
                          "li",
                          { staticClass: "yxtbiz_appraise_file_preview" },
                          [
                            _c("yxt-svg", {
                              staticClass: "yxtbiz_appraise_file_icon",
                              attrs: {
                                "remote-url":
                                  _vm.$staticBaseUrl +
                                  "assets/24ea854a/176467f6/",
                                "icon-class": "file_preview",
                                width: "24px",
                                height: "24px",
                              },
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.dataForm.template.name)),
                            ]),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isPublished,
                                  expression: "!isPublished",
                                },
                              ],
                              staticClass: "yxt-icon-close",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelQuestion()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("choose-formwork-drawer", {
        ref: "choose-formwork",
        attrs: { type: _vm.dataForm.type },
        on: { formWork: _vm.handleChooseFormwork },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }